<script>
  let email = "";
  let error = "";
  let signUpSuccess = false;

  async function handleSubmit(event) {
    const payload = {
      email,
    };
    console.log(payload);
    try {
      const result = await fetch(
        `${__myapp.env.CWS_API_URL}/newsletterRegistration`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...payload
          })
        }
      );

    console.log(result);

    if (!result.ok) {
      error = result.statusText;
      return;
    }

      signUpSuccess = true;
    } catch (e) {
      console.error(`Could not sign up for newsletter ${e}`);
    }
  }
</script>

<style>

</style>

<div class="white-bg">
  <div class="white primary-bg">
    <div class="container">
      <div class="row">
        <div class="col">
        { #if signUpSuccess }
        <div>Thank you for signing up</div>

        { :else }
        <div>{error || ''}</div>
          <div class="col-md-8 ml-auto mr-auto">
            <h1 class="bold">Sign up for our newsletter</h1>
          </div>

          <div class="form-group">
            <input
              class="form-control"
              bind:value={email}
              placeholder="Your e-mail" />
          </div>

          <div class="form-group">
            <button
              on:click|preventDefault={handleSubmit}
              class="btn btn-primary">
              Sign up
            </button>
          </div>
        {/if}
        </div>
      </div>
    </div>
  </div>
</div>
